import { cn } from '@/lib/utils';

interface ITabShellProps {
  /** Scrollable body content (typically SectionCards). */
  children: React.ReactNode;
  /** Pinned footer, rendered outside the scroll area (typically StickyActionBar). */
  footer?: React.ReactNode;
  /** Extra classes for the scrollable body (defaults to `p-6`). */
  bodyClassName?: string;
}

/**
 * Standard fill-tab layout for the bot config surfaces: a column that fills the
 * tab card, with a single scrollable body and an always-visible pinned footer.
 * Mirrors the structure hand-written in Settings / Book Demo / Human Handoff so
 * every non-form tab (e.g. Video Avatar) reads identically.
 *
 * For react-hook-form tabs that need the <form> to be the flex column, keep the
 * explicit `flex-1 min-h-0 flex flex-col` markup instead.
 */
const TabShell: React.FC<ITabShellProps> = ({ children, footer, bodyClassName }) => (
  <div className="flex-1 min-h-0 flex flex-col">
    <div className={cn('flex-1 min-h-0 overflow-y-auto', bodyClassName ?? 'p-6')}>
      {children}
    </div>
    {footer}
  </div>
);

export default TabShell;
